/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AnalogicFacesPainScaleAliases {
  CONTEXTUAL_BAR_ANALOGIC_FACES = 'contextual-bar-analogic-faces',
  LAYOUT_ANALOGIC_FACES = 'layout-analogic-faces',
  PAIN_SCALE_ANALOGIC_FACES = 'pain-scale-analogic-faces',
  PANEL_ANALOGIC_FACES = 'panel-analogic-faces',
}
export { AnalogicFacesPainScaleAliases };
